import React from 'react'

import styles from './styles.module.scss'

interface ClusterPorps {
  lat: number
  lng: number
  size: string
  width: string
  height: string
  onClick?: () => void
}

export const Cluster = ({ size, height, width, onClick }: ClusterPorps) => {
  return (
    <div>
      <div
        className={styles.clusterMarker}
        style={{ cursor: 'pointer', width, height }}
        onClick={onClick}
      >
        {size}
      </div>
    </div>
  )
}
